import styled from '@emotion/styled'
import { Gray200, Primary500 } from '@mehilainen/mds-customer/colors'

const SmallLoader = styled.div`
  border: 5px solid ${Gray200};
  border-top: 5px solid ${Primary500};
  border-radius: 50%;
  width: 30px;
  height: 30px;
  animation: spin 1s linear infinite;

  @keyframes spin {
    0% {
      transform: rotate(0deg);
    }
    100% {
      transform: rotate(360deg);
    }
  }
`
export default SmallLoader
